/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { forwardRef } from 'react';

import { cssMap, jsx } from '@compiled/react';

import { fg } from '@atlaskit/platform-feature-flags';
import { token } from '@atlaskit/tokens';
import {
	TAB_GAP,
	TAB_GAP_OLD,
	UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BORDER_VAR,
} from '@atlassian/navigation-kit-common';

const ResponsiveNav = forwardRef<
	HTMLElement,
	React.PropsWithChildren<{ label: string; id?: string }>
>(({ children, label, id }, ref) => (
	<nav
		aria-label={label}
		css={[
			styles.root,
			fg('blu-6305_tab_item_styling_in_horizontal_navigation') && styles.smallerDividerLine,
			fg('blu-6305_tab_item_styling_in_horizontal_navigation') && styles.new,
		]}
		ref={ref}
		id={id}
	>
		{children}
	</nav>
));

const styles = cssMap({
	root: {
		display: 'flex',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		gap: `${TAB_GAP_OLD}px`,
		position: 'relative',
		minWidth: 0,
		paddingLeft: token('space.300'),
		paddingRight: token('space.300'),
		// Underline separating tabs from page content
		'&::before': {
			content: "''",
			position: 'absolute',
			bottom: 0,
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
			background: `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BORDER_VAR}, ${token('color.border')})`,
			height: token('space.025'),
			left: 0,
			right: 0,
		},
	},
	// merge to main styling and remove it when cleaning blu-6305_tab_item_styling_in_horizontal_navigation
	smallerDividerLine: {
		'&::before': {
			height: '1px',
		},
	},
	new: {
		// merge to main styling and remove it when cleaning blu-6305_tab_item_styling_in_horizontal_navigation
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		gap: `${TAB_GAP}px`,
	},
});

export default ResponsiveNav;
